var $name="shell/registry/events",$path="app/modules/shell/registry/events.js",$this={$name,$path,};export const activateEvent = 'Activate';
export const mountEvent = 'Mount';
export const unmountEvent = 'Unmount';
